import {ModalFormFieldTypes} from 'components/formItems/FormGroup/FormGroup';

const fields: ModalFormFieldTypes[] = [
	{
		name: 'number',
		type: 'text',
		label: 'Հրամանի համար',
		colProps: {
			xs: 24,
			lg: 12
		},
		inputProps: {
			className: 'bordered-input'
		},
		isRequired: false,
		visibility: ['VIEW'],
		disabledAt: ['VIEW']
	},
	{
		name: 'typeID',
		type: 'select',
		label: 'Հրամանի տեսակ',
		dictionaryApiPath: 'commandType',
		colProps: {
			xs: 24,
			lg: 12
		},
		selectProps: {
			className: 'bordered-select'
		},
		isRequired: false,
		visibility: ['VIEW'],
		disabledAt: ['VIEW']
	},
	{
		name: 'date',
		type: 'date',
		label: 'Հրամանի ամսաթիվ',
		colProps: {
			xs: 24,
			lg: 12
		},
		datePickerProps: {
			className: 'bordered-input'
		},
		isRequired: false,
		visibility: ['VIEW'],
		disabledAt: ['VIEW']
	},
	{
		name: 'effectiveDate',
		type: 'date',
		label: 'Հրամանը ուժի մեջ է սկսած՝',
		colProps: {
			xs: 24,
			lg: 12
		},
		datePickerProps: {
			className: 'bordered-input'
		},
		isRequired: false,
		visibility: ['VIEW'],
		disabledAt: ['VIEW']
	},
	{
		name: 'title',
		type: 'text',
		label: 'Հրամանի վերնագիր',
		colProps: {
			xs: 24,
			lg: 12
		},
		inputProps: {
			className: 'bordered-input'
		},
		isRequired: false,
		visibility: ['VIEW'],
		disabledAt: ['VIEW']
	},
	{
		name: 'titleFr',
		type: 'text',
		label: 'Հրամանի վերնագիր (Ֆրանսերեն)',
		colProps: {
			xs: 24,
			lg: 12
		},
		inputProps: {
			className: 'bordered-input'
		},
		isRequired: false,
		visibility: ['VIEW'],
		disabledAt: ['VIEW']
	},
	{
		name: 'content',
		type: 'textArea',
		label: 'Հրամանի տեքստ',
		colProps: {
			xs: 24
		},
		textAreaProps: {
			rows: 6,
			className: 'ant-textarea bordered-textArea'
		},
		isRequired: false,
		visibility: ['VIEW'],
		disabledAt: ['VIEW']
	},
	{
		name: 'contentFr',
		type: 'textArea',
		label: 'Հրամանի տեքստ (Ֆրանսերեն)',
		colProps: {
			xs: 24
		},
		textAreaProps: {
			rows: 6,
			className: 'ant-textarea bordered-textArea'
		},
		isRequired: false,
		visibility: ['VIEW'],
		disabledAt: ['VIEW']
	},
	{
		type: 'file',
		label: 'Կից փաստաթուղթ',
		name: 'path',
		editableFile: true,
		isRequired: false,
		visibility: ['VIEW'],
		disabledAt: ['VIEW']
	}
];

export default fields;
